export enum ApiEndpoint {
  GetPerson = 'me',
  GetVersionCheck = 'version-check',
  GetUserPreference = 'user-preference',

  // News and Events
  GetNews = 'news',
  GetEvents = 'events',

  // Documents
  GetAllClientDocuments = 'client-documents',
  GetClientDocumentTypes = 'client-documents/types',
  PostClientDocumentsRead = 'client-documents/read',
  GetFirmUserClientDocument = 'clients/{personCode}/documents/{id}',

  // ACCOUNTS
  GetAccount = 'accounts/{code}',
  GetAccountValuation = 'accounts/{code}/valuation',
  GetAccountAssets = 'accounts/{code}/assets',
  GetAccountAssetsDownload = 'accounts/{code}/assets/export',
  GetAccountAsset = 'accounts/{code}/assets/id/{sedol}',
  GetAccountSecurityTxs = 'accounts/{code}/securitytransactions',
  GetAccountSecurityTxsDownload = 'accounts/{code}/securitytransactions/export',
  GetAccountCashTxs = 'accounts/{code}/cashtransactions',
  GetAccountCashTxsDownload = 'accounts/{code}/cashtransactions/export',
  GetAccountCashTxOptions = 'accounts/{code}/cashtransactions/options',

  // CLIENT-LEVEL
  GetAssets = 'assets',
  GetAllPortfoliosAsset = 'assets/id/{sedol}',

  // PORTFOLIOS
  GetAllPortfolios = 'portfolios',
  GetPortfolio = 'portfolios/{code}',
  GetPortfolioAssets = 'portfolios/{code}/assets',
  GetPortfolioAssetsDownload = 'portfolios/{code}/assets/export',
  GetSecuritiesDownload = 'assets/export',
  GetPortfolioAsset = 'portfolios/{code}/assets/id/{sedol}',
  GetPortfolioValuation = 'portfolios/{code}/valuation',
  GetPortfolioPerformance = 'portfolios/{code}/performance',
  PutPortfolioExclusions = 'portfolios/exclude',

  // PASSKEYS
  GetPasskeyCredentials = 'passkey/credentials',
  RenamePasskeyCredential = 'passkey/credentials/{credentialId}',
}
